/**
 * Strip job title / role annotations from a display name.
 *
 * Many users — particularly from SkyUK — have their job title embedded in
 * their name field:
 *   "Boxall, Luke (Software Engineer - Sky)"
 *   "Proudman, Philip (Software Developer (C++ - Sky))"
 *   "Hossain, Riyadh (Senior Engineering Manager) <Riyadh.Hossain"
 *
 * This function strips everything from the first " (" onwards, then also
 * removes any trailing " <..." fragment (LDAP/email leakage), and trims
 * the result.
 *
 * Examples:
 *   stripNameTitle("Boxall, Luke (Software Engineer - Sky)")
 *     → "Boxall, Luke"
 *   stripNameTitle("Proudman, Philip (Software Developer (C++ - Sky))")
 *     → "Proudman, Philip"
 *   stripNameTitle("Hossain, Riyadh (Senior Engineering Manager) <Riyadh.Hossain")
 *     → "Hossain, Riyadh"
 *   stripNameTitle("Laverty, Brett")
 *     → "Laverty, Brett"   (no-op)
 */
export function stripNameTitle(name: string | null | undefined): string {
  if (!name) return '';
  return name
    .replace(/\s*\(.*$/, '')   // strip " (Title...)" and everything after
    .replace(/\s*<.*$/, '')    // strip " <email>" leakage
    .trim();
}
